<template>
  <v-app class="no-scroll-height">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  created() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });
  }
};
</script>

<style lang="scss">
html {
  overflow: hidden;
}

.no-scroll-height {
  .v-application--wrap {
    min-height: auto;
  }
}

#local {
  height: 120px;
  width: 95px;
  border-radius: 4px;
  overflow: hidden;

  video {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover !important;
  }

  audio {
    height: 0 !important;
    width: 0 !important;
  }
}

#remote {
  position: absolute;
  top: env(safe-area-inset-top);
  right: env(safe-area-inset-right);
  height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom));
  width: 100vw;
  z-index: 5;

  video {
    height: 100% !important;
    width: 100% !important;
    object-fit: cover !important;
  }

  audio {
    height: 0 !important;
    width: 0 !important;
  }
}
</style>
